(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('UserListController', UserListController);
    

    UserListController.$inject = [
        'userService', '$templateCache', '$state', '$scope', '$filter', '$q', 'uiGridConstants', 'restrictionService' 
    ];

    function UserListController(userService, $templateCache, $state, $scope, $filter, $q, uiGridConstants, restrictionService){
        // jshint maxstatements:false

		/* PRIVATE VARIABLES */
		var templates = {
            accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
            rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),

		};

		var sorting = {
			field: null,
			direction: null
		};

        var row = { 
            'state' : 'iconOffline', 
            'name' : 'Rodolfo', 
            'lastName': 'Llador', 
            'user': 'demogru01',  
            'actions' : 'editar/eliminar'
        };
        
        var vm = this;
        vm.restrictionService = restrictionService; 

		vm.listaUsuariosActivos = true;
		vm.gridData = [];
		vm.loaded = false;

		vm.appliedFilters = [];
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,
			enableFilter: true,
			paginationPageSizes: [25, 50, 75],
			paginationPageSize: 25,
			useExternalPagination: true,
			useExternalSorting: true,

			enableRowSelection: true,
			multiSelect: true,

			enableColumnResizing: true,

			enableColumnMenus: false,
			treeRowHeaderAlwaysVisible: false,
			virtualizationThreshold: 200,
			primaryKey: 'usuarioid',
            columnDefs: [

              

                {
                    name: 'nombre',
                    displayName: 'Nombre',
                    resizable: true
                },

                {
                    name: 'apellidos',
                    displayName: 'Apellidos',
                    resizable: true
                },
                { 
                    name: 'rol',
                    displayName: 'Rol',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },
                {
                    name: 'idusuario',
                    displayName: 'Usuario',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },
                {
                    name: 'estado',
                    displayName: 'Estado',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true,
                    cellTemplate: '<div ng-if="row.entity.estadoWeb == 0"><div class="ui-grid-cell-contents">Offline</div></div>'
                        + '<div ng-if="row.entity.estado == 1  && row.entity.estadoMovil == 1"><div class="ui-grid-cell-contents">Online (mobil)</div></div>'
                        + '<div ng-if="row.entity.estado == 1  && row.entity.estadoMovil == 0"><div class="ui-grid-cell-contents">Online (web)</div></div>'
                        + '<div ng-if="row.entity.estado == 2"><div class="ui-grid-cell-contents">Active (web)</div></div>'  
                        + '<div ng-if="row.entity.estado == 3"><div class="ui-grid-cell-contents">Connected (web)</div></div>'  
                },
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
					resizable: true,
					cellClass: 'overflow',
					cellTemplate: templates.accionesCellTemplate
                }
			],
			data: 'gridData',

			onRegisterApi: function (gridApi) {
				vm.gridApi = gridApi;
				vm.gridApi.grid.options.enableExpandAll = false;
			}
        };
		vm.searchText = '';
		vm.filterGrid = filterGrid;
		vm.goToEdit = goToEdit;
		vm.changeGrid = changeGrid;
		vm.refreshGrid = refreshGrid;
		vm.remove = remove;
		vm.deleteAllItems = deleteAllItems;
        vm.selectAll = selectAll;
        vm.focusRow = focusRow;
        vm.isFocused = isFocused;
		vm.clearAll = clearAll;
		vm.invertSelection = invertSelection;
		vm.selectOrClear = selectOrClear;

        (function () {
            loadData();
		})();

		function filterGrid() {
			if (vm.searchText !== '') {
				$scope.gridData = $filter('searchFilter')(vm.gridData, 
					{ nombre: vm.searchText, apellidos: vm.searchText }, true);
			}
			else {
				$scope.gridData = vm.gridData;
            }
            vm.gridOptions.totalItems = $scope.gridData.length;
            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
		}

		$scope.$on('fleetdata-refreshed', function (event, args) {
			//Save selected rows to mantain the selection after refreshing the data
			var selected = vm.gridApi.selection.getSelectedRows();
			filterGrid();
			vm.clearAll();
			var list = $scope.gridData;
			for (var i = 0; i < list.length; i++) {
				var found = $filter('filter')(selected, { 'usuarioid': list[i].usuarioid });
				if (found[0]) {
					vm.gridApi.grid.modifyRows($scope.gridData);
					vm.gridApi.selection.selectRow($scope.gridData[i]);
				}
			}
		});

		function loadData() {
			vm.loaded = false;
            userService.getAllUsersData().then(function (result) {
				$scope.gridData = result.data.list;
				vm.gridData = result.data.list;
				vm.loaded = true;
			});

		}

        function goToEdit(obj) {
            restrictionService.hasPermission(2, 'usuario', 'flota.configuracion.editarUsuario', {
            	'id': obj.usuarioid
            });
		}

		function refreshGrid() {
			if (vm.listaUsuariosActivos) {
				loadData();
			}
			else {
				loadDataDadosDeBaja();
			}
		}

		function changeGrid() {
			if (vm.listaUsuariosActivos) {
				vm.listaUsuariosActivos = false;
				loadDataDadosDeBaja();
			}
			else {
				vm.listaUsuariosActivos = true;
				loadData();
			}
		}

        function remove(usuarioId) {
            if (!restrictionService.hasPermission('eliminar', 'usuario')) return; 

			userService.deleteById(usuarioId).then(function (result) {
				loadData();
			});
		}

        function deleteAllItems() {
            if (!restrictionService.hasPermission('eliminar', 'usuario')) return; 

			var promises = [];
			var selected = vm.gridApi.selection.getSelectedRows();
			for (var i = 0; i < selected.length; i++) {
				var promise = userService.deleteById(selected[i].usuarioid);
				promises.push(promise);
			}
			$q.all(promises).then(refreshGrid);
		}

		function loadDataDadosDeBaja() {
			userService.getListDadosDeBaja(sorting, vm.appliedFilters).then(function (result) {
				vm.gridData = result.data.list;
				$scope.gridData = result.data.list;

			});
        }

        function focusRow(obj) {
            vm.focusedRow = obj.usuarioid;
        }

        function isFocused(obj) {
            return vm.focusedRow === obj.usuarioid;
        }

		function selectAll() {
			vm.gridApi.selection.selectAllRows();
		}
		function clearAll() {
			vm.gridApi.selection.clearSelectedRows();
		}
		function invertSelection() {
			var selected = vm.gridApi.selection.getSelectedRows();

			vm.selectAll();

			for (var i = 0; i < selected.length; i++) {
				vm.gridApi.selection.unSelectRow(selected[i]);
			}
		}
		function selectOrClear() {
			if (vm.gridApi.selection.getSelectAllState()) {
				vm.clearAll();
			} else {
				vm.selectAll();
			}
		}
    }

})();